import { render, staticRenderFns } from "./ConsultaCrd.vue?vue&type=template&id=93d966c4&scoped=true"
import script from "./ConsultaCrd.vue?vue&type=script&lang=js"
export * from "./ConsultaCrd.vue?vue&type=script&lang=js"
import style0 from "./ConsultaCrd.vue?vue&type=style&index=0&id=93d966c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d966c4",
  null
  
)

export default component.exports